<div>
    <app-header></app-header>
    <div class="container-fluid finzy-font-color">
        <div class="finzyfont">
            <app-investormenu></app-investormenu>
            <div class="col-md-9 col-md-offset-1">
                <div class="row">
                    <p class="breadcrumbs-finzy"><a class="bread" [routerLink]="['/investments']">Investments</a>&nbsp;/
                        Allocated Loans</p>
                </div>
                <div class="row">
                    <div class="row">
                        <h3 class="text-center mb-4">
                            Hi {{investorName | titlecase}}, here are your allocated loans
                        </h3>
                        <div class="center-align pl-4 pr-4">
                            <div class="text-center content ng-tns-c380-4 transparent-border grey-section w-100 mt-1">
                                <p class="m-0 p-4">You have currently opted <span
                                        *ngIf="!allocatedLoanNotification">not</span> to receive an email notification
                                    when a new loan is allocated to any of your investment portfolios.
                                    <br />If you wish to change this preference, please click <a
                                        href="/preferences">here</a>. You can reverse the allocation from the list below
                                    within the reversal expiry time.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div *ngIf="dataSource.data.length > 0"
                            class="table-container {{isMobile?'':'responsive-table'}}">
                            <mat-table [dataSource]="dataSource" class="finzyfont margin-top-20" multiTemplateDataRows>
                                <ng-container matColumnDef="borrowerDetails">
                                    <mat-header-cell *matHeaderCellDef class="col-150">Borrower</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-150">
                                        <a (click)="viewBorrowerDetails(element)"
                                            class="small-text cursor-pointer">Borrower Details</a>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="rating">
                                    <mat-header-cell *matHeaderCellDef class="col-88">Rating</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-88">
                                        <span class="small-text">{{element.rating}}</span>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="tenure">
                                    <mat-header-cell *matHeaderCellDef class="col-88">Tenure</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-88">
                                        <span class="small-text">{{element.tenure}} M</span>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="loanAmount">
                                    <mat-header-cell *matHeaderCellDef class="col-100">Loan Amount</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-100">
                                        <app-indian-currency-formatter [amount]="element.loan_amount">
                                        </app-indian-currency-formatter>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="filledPercentage">
                                    <mat-header-cell *matHeaderCellDef class="col-88">Filled %</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-88">
                                        <span class="small-text">{{element.filled_percentage}}%</span>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="loanPurpose">
                                    <mat-header-cell *matHeaderCellDef class="col-100">Loan Purpose</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-100">
                                        <span class="small-text">{{element.loan_reason}}</span>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="investmentInLoan">
                                    <mat-header-cell *matHeaderCellDef class="col-150">Investment in Loan
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-150">
                                        <app-indian-currency-formatter [amount]="element.investmentInLoan">
                                        </app-indian-currency-formatter>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="roi">
                                    <mat-header-cell *matHeaderCellDef class="col-88">ROI</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-88">
                                        <span class="small-text">{{element.roi}}%</span>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="reversalExpiryTime">
                                    <mat-header-cell *matHeaderCellDef class="col-150">Reversal Expiry</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-150">
                                        <span class="small-text">{{element.reversalExpiryTime}}</span>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="reversal">
                                    <mat-header-cell *matHeaderCellDef class="col-110"></mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-110">
                                        <div *ngIf="!element.isReversalExpired">
                                            <a *ngIf="!lenderAllocatedLoanIdToBeDeleted || lenderAllocatedLoanIdToBeDeleted !== element.loanId"
                                                (click)="reverseInvestment(element)"
                                                class="small-text cursor-pointer">Reverse Allotment</a>
                                            <div class="center-align margin-top-20 margin-bottom-20"
                                                *ngIf="lenderAllocatedLoanIdToBeDeleted === element.loanId">
                                                <mat-spinner [diameter]="35"></mat-spinner>
                                            </div>
                                        </div>
                                        <div *ngIf="element.isReversalExpired">
                                            <span class="text-color-grey small-text">Reverse Allotment</span>
                                        </div>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="accordion_arrow">
                                    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                                    <mat-cell *matCellDef="let element" style="justify-content: flex-end;max-width: 46px;">
                                        <mat-icon style="font-family: 'Material Icons';font-size: 18px;">{{element == expandedElement ?
                                            'arrow_drop_up' : 'arrow_drop_down'}}
                                        </mat-icon>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="expandedDetail">
                                    <mat-cell *matCellDef="let element">
                                        <div class="accordion-element-detail" *ngIf="isMobile"
                                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">

                                            <div
                                                style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                                                <div style="padding: 8px;width: 50%;">
                                                    Loan Amount
                                                </div>
                                                <div style="padding: 8px;width: 50%;">
                                                    <span>
                                                        <app-indian-currency-formatter [amount]="element.loan_amount">
                                                        </app-indian-currency-formatter>
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                                                <div style="padding: 8px;width: 50%;">
                                                    Filled %
                                                </div>
                                                <div style="padding: 8px;width: 50%;">
                                                    <span>{{element.filled_percentage}}%</span>
                                                </div>
                                            </div>
                                            <div
                                                style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                                                <div style="padding: 8px;width: 50%;">
                                                    Loan Purpose
                                                </div>
                                                <div style="padding: 8px;width: 50%;">
                                                    <span>{{element.loan_reason}}</span>
                                                </div>
                                            </div>
                                            <div
                                                style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                                                <div style="padding: 8px;width: 50%;">
                                                    Investment in Loan
                                                </div>
                                                <div style="padding: 8px;width: 50%;">
                                                    <span>
                                                        <app-indian-currency-formatter
                                                            [amount]="element.investmentInLoan">
                                                        </app-indian-currency-formatter>
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                                                <div style="padding: 8px;width: 50%">
                                                    ROI
                                                </div>
                                                <div style="padding: 8px;width: 50%;">
                                                    <span>{{element.roi}}%</span>
                                                </div>
                                            </div>
                                            <div
                                                style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;line-height: 1;">
                                                <div style="padding: 8px;width: 50%;">
                                                    Reversal Expiry
                                                </div>
                                                <div style="padding: 8px;width: 50%;">
                                                    <span>{{element.reversalExpiryTime}}</span>
                                                </div>
                                            </div>
                                            <div
                                                style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;line-height: 1;">
                                                <div style="padding: 8px;width: 50%;">
                                                    reversal
                                                </div>
                                                <div style="padding: 8px;width: 50%;">
                                                    <div *ngIf="!element.isReversalExpired">
                                                        <a *ngIf="!lenderAllocatedLoanIdToBeDeleted || lenderAllocatedLoanIdToBeDeleted !== element.loanId"
                                                            (click)="reverseInvestment(element)"
                                                            class="small-text cursor-pointer">Reverse Allotment</a>
                                                        <div class="center-align margin-top-20 margin-bottom-20"
                                                            *ngIf="lenderAllocatedLoanIdToBeDeleted === element.loanId">
                                                            <mat-spinner [diameter]="35"></mat-spinner>
                                                        </div>
                                                    </div>
                                                    <div *ngIf="element.isReversalExpired">
                                                        <span class="text-color-grey small-text">Reverse
                                                            Allotment</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-cell>
                                </ng-container>
                                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                <mat-row *matRowDef="let element; columns: displayedColumns;"
                                    class="accordion-element-row"
                                    [class.accordion-expanded-row]="expandedElement === element"
                                    (click)="expandedElement = expandedElement === element ? null : element"></mat-row>
                                <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="accordion-detail-row">
                                </mat-row>

                            </mat-table>

                            <mat-paginator [length]="5" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]"></mat-paginator>

                            <div class=" margin-bottom-20"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>